var map = {
	"./chitra.webp": 43920,
	"./dharanisri.webp": 58174,
	"./hemalatha.webp": 95380,
	"./jagadeesan.webp": 31638,
	"./kalpana.webp": 85483,
	"./karthikeyan.webp": 26498,
	"./kavitha.webp": 57309,
	"./natarajan.webp": 30201,
	"./poongodi.webp": 25394,
	"./pyingkodi.webp": 17873,
	"./rahunathan.webp": 5807,
	"./sathiyavathi.webp": 16168,
	"./sindhu.webp": 14234,
	"./sivabalan.webp": 70262,
	"./tamilarasi.webp": 73072,
	"./vijayakumar.webp": 23999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32343;